
  import { defineComponent } from 'vue';
  import { mapGetters } from 'vuex';

  import { VED_COMMON_GETTERS_NAME } from '../../store/vedCommon/name';
  import BaseInfo from '../common/base-info/BaseInfo.vue';
  import { TBaseInfoItem } from '../common/base-info/types';

  export default defineComponent({
    name: 'ForeignTradeByCountriesBaseInfo',
    components: {
      BaseInfo,
    },
    props: {
      productText: {
        type: String,
      },
    },
    computed: {
      ...mapGetters({
        getCountriesTree: VED_COMMON_GETTERS_NAME.getCountriesTree,
      }),
      getItems(): TBaseInfoItem[] {
        return [this.getProductsItem, this.getSourceItem];
      },
      getProductsItem(): TBaseInfoItem {
        return {
          label: 'Товар',
          value: this.productText ?? '',
          isLoading: this.productText == null,
        };
      },
      getSourceItem(): TBaseInfoItem {
        return {
          label: 'Источник',
          value: 'Федеральная таможенная служба',
          isLoading: false,
        };
      },
    },
  });
